export const error = state => state.error
export const isLoading = state => state.isLoading
export const activated = state => state.activated
export const expiredToken = state => state.expiredToken
export const invalidToken = state => state.invalidToken
export const emailSent = state => state.emailSent
